import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { convertParseDateTime } from 'src/app/shared/utils/utility.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { IAVailableUnit } from '../activity/user-card.interface';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { ViewAllAvailableUnitsComponent } from './view-all-available-units/view-all-available-units.component';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-dashboard-unit-card',
  templateUrl: './dashboard-unit-card.component.html',
  styleUrls: ['./dashboard-unit-card.component.scss'],
})
export class DashboardUnitCardComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  @Input() siteId!: string;
  subscription: Subscription | undefined;
  sharedData: any;

  @Input() availableUnit!: IAVailableUnit;
  constructor(
    private helperService: HelperService,
    public dashboardManagementService: DashboardManagementService,
    public sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.subscription = this.sharedDataService?.currentData?.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   *
   * @param time get time format
   * @returns return formated time
   */
  getContentFormatDate(time: string, format: 'hh:mma') {
    return convertParseDateTime(time, 't', format);
  }

  /**
   * Function used as the trackBy function for ngFor directive.
   * It tracks the options in the ngFor loop based on the provided index and option.
   *
   * @param index The index of the current option in the ngFor loop.
   * @param option The current option object in the ngFor loop.
   * @returns The option itself as the unique identifier for tracking.
   */
  trackByOption(index: number, option: any) {
    return option;
  }

  viewAllAvailableUnits() {
    const dialogInstance = this.helperService.openModalDialog(
      ViewAllAvailableUnitsComponent,
      {
        siteId: this?.siteId,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
  }
  /**
   * Handle the click event when accessing a specific resource.
   * @param unitData - The unitData object representing the resource.
   */
  onClickAvailableUnit(unitData: any) {
    // Set the selected building, floor, and access point or unit data
    this.sharedDataService.setAllEntityData(unitData);
    // Navigate to the site management page
    this.router.navigate(['../site-management']);
  }
}
